import { Injectable, signal, computed } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly _loading = signal(false);
  readonly isSpinner = computed(() => this._loading());

  display(value: boolean) {
    this._loading.set(value);
  }

  handleRequest<T>(request$: Observable<T>): Observable<T> {
    this.display(true);

    return request$.pipe(finalize(() => this.display(false)));
  }
}
